export type BreadcrumbItem = {
  label: string;
  href?: string;
  isCurrent?: boolean;
};

export const BREADCRUMB_ITEMS: BreadcrumbItem[] = [
  { label: 'Home', href: '#' },
  { label: 'Development Process', href: '#' },
  { label: 'Discovery', isCurrent: true },
];

export const BREADCRUMB_STORY_ITEMS: BreadcrumbItem[] = [
  { label: 'Home', href: '/' },
  { label: 'Library', href: '/library' },
  { label: 'Data', isCurrent: true },
];
